<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true" size="medium">
          <el-form-item label="产品名称：">
            <el-input v-model="searchForm.PRODUCT_NAME" clearable></el-input>
          </el-form-item>
          <el-form-item label="产品编码：">
            <el-input v-model="searchForm.PRODUCT_CODE" clearable></el-input>
          </el-form-item>
          <el-form-item label="产品分类：">
            <el-input v-model="searchForm.PRODUCT_SORT" clearable></el-input>
          </el-form-item>
          <el-form-item label="供应商：">
            <el-select filterable v-model="searchForm.TC_COMPANY" placeholder="请选择供应商" :clearable="true">
              <el-option v-for="item in companys" :key="item.SUPPLIER_ID" :label="item.AB_NAME" :value="item.SUPPLIER_ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期范围：">
            <el-date-picker v-model="searchForm.START_END" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" :picker-options="pickerOptions" value-format="yyyy-MM-dd" :clearable="false">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="btn" @click="onSubmit" :loading="loadSearch">筛选</el-button>
          </el-form-item>
          <el-form-item>
            <el-button class="btn" @click="exportData">导出</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row style="margin-bottom: 20px; font-weight: 700">
    </el-row>
    <el-row>
      <el-col>
        <el-table border stripe :data="tableData" max-height="520">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="SEND_DAY" label="订单日期"></el-table-column>
          <el-table-column prop="SUPPLIER_NAME" label="供应商"></el-table-column>
          <el-table-column prop="PRODUCT_SORT" label="产品分类"></el-table-column>
          <el-table-column prop="INNER_CODE" label="产品编码"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="订购数量"></el-table-column>
          <el-table-column prop="REAL_COUNT" label="实收数量"></el-table-column>
          <el-table-column prop="PRODUCT_FEE" label="订购金额"></el-table-column>
          <el-table-column prop="REAL_FEE" label="实收金额"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <div class="pagination_box" style="text-align: right">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { supplierList } from 'api/systemSetting';
import http from '@/assets/common/http';
import date, { 判断日期范围是否超过限制 } from '@/assets/common/date';

export default {
  data() {
    return {
      // loading: false,
      companys: [],
      loadSearch: false,
      projects: [],
      searchForm: {
        START_END: [date(new Date().getTime() - 3600 * 1000 * 24 * 7, '%F'), date(new Date(), '%F')],
      },
      salesStatistics: [],
      tableData: [],
      totalCount: 0,
      pageSize: 15,
      currentPage: 1,
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [date(start, '%F'), date(end, '%F')]);
            },
          },
        ],
      },
      companyLists: [],
      currentOrderFlag: 0,
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.HISTORY_OUT_DATA_CONDITION.CONDITION) {
      this.searchForm = this.HISTORY_OUT_DATA_CONDITION.CONDITION;
      this.currentPage = this.HISTORY_OUT_DATA_CONDITION.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryData();
    this.queryGYSData();
  },
  computed: {
    HISTORY_OUT_DATA_CONDITION() {
      return this.$store.state.HISTORY_OUT_DATA_CONDITION;
    },
  },
  methods: {
    // 拉取供应商
    queryGYSData() {
      const params = {
        PAGEINDEX: 0,
        PAGESIZE: 9999,
      };
      supplierList(params).then((result) => {
        if (result.length !== 0) {
          this.companys = result[0].list;
        } else {
          this.companys = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 导出
    exportData() {
      if (判断日期范围是否超过限制(...this.searchForm.START_END)) {
        this.$message.show({ text: '选择的日期范围不应超过31天', type: 'warning' });
        return;
      }
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 70,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        START_DAY: this.searchForm.START_END[0],
        END_DAY: this.searchForm.START_END[1],
      };
      if (this.searchForm.TC_COMPANY) {
        params.SUPPLIER_ID = this.searchForm.TC_COMPANY;
      }
      if (this.searchForm.PRODUCT_SORT) {
        params.PRODUCT_SORT = this.searchForm.PRODUCT_SORT;
      }
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      if (this.searchForm.PRODUCT_CODE) {
        params.PRODUCT_CODE = this.searchForm.PRODUCT_CODE;
      }
      http.post(params).then((result) => {
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // -----------------------------拉取数据
    queryData() {
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 69,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PAGEINDEX: this.currentPage - 1,
        PAGESIZE: this.pageSize,
        START_DAY: this.searchForm.START_END[0],
        END_DAY: this.searchForm.START_END[1],
      };
      if (this.searchForm.TC_COMPANY) {
        params.SUPPLIER_ID = this.searchForm.TC_COMPANY;
      }
      if (this.searchForm.PRODUCT_SORT) {
        params.PRODUCT_SORT = this.searchForm.PRODUCT_SORT;
      }
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      if (this.searchForm.PRODUCT_CODE) {
        params.PRODUCT_CODE = this.searchForm.PRODUCT_CODE;
      }
      http.post(params).then((result) => {
        if (result.length > 0) {
          this.totalCount = result[0].TOTAL;
          this.tableData = result[0].list;
          this.tableData.forEach((item) => {
            // 采购金额
            item.PRODUCT_FEE = (Math.round(Number(item.REAL_PRICE) * Number(item.PRODUCT_COUNT) * 100) / 100).toFixed(2);
            // 实收金额
            item.REAL_FEE = (Math.round(Number(item.REAL_PRICE) * Number(item.REAL_COUNT) * 100) / 100).toFixed(2);
          });
          this.$store.dispatch('SET_HISTORY_OUT_DATA_CONDITION', {
            CONDITION: this.searchForm,
            DATA: this.tableData,
            TOTAL_COUNT: this.totalCount,
            CURRENT_PAGE: this.currentPage,
          });
        } else {
          this.totalCount = 0;
          this.tableData = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // ---------------------------筛选
    onSubmit() {
      this.currentPage = 1;
      this.queryData();
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryData();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/tableManage/SupplierPurchaseSchedule.vue